import Calendar from 'app/shared/components/CalendarSelect'
import CompCalendar from 'app/shared/components/InputCalendar'
import * as React from 'react'
import { Button } from 'primereact/button'
import {
    DialogCalendar,
    DialogCalendarRef,
} from 'app/shared/components/DialogCalendar'
import Input from 'app/shared/components/InputField'
import ScrollPicker from 'app/shared/components/ScrollPicker'

const PgCalendar: React.FC = () => {
    const [testDate, setTestDate] = React.useState(new Date())
    const ref = React.useRef<DialogCalendarRef>(null)

    const [monthDate, setMonthDate] = React.useState(new Date())
    const monthRef = React.useRef<DialogCalendarRef>(null)

    //Picker Test ----------------------------------------------
    const [picker, setPicker] = React.useState(false)
    const yearsitem = ['1년', '2년', '3년', '4년', '5년']
    const monthsitem = [
        '0개월',
        '1개월',
        '2개월',
        '3개월',
        '4개월',
        '5개월',
        '6개월',
        '7개월',
        '8개월',
        '9개월',
        '10개월',
        '11개월',
        '12개월',
    ]
    const [selectedYear, setSelectedYear] = React.useState('')
    const [selectedMonth, setSelectedMonth] = React.useState('')
    return (
        <>
            <CompCalendar placeholder="테스트" value={new Date()} />
            <br />
            <Calendar
                selected="week"
                // today={new Date('2025-02-15')}
                onSearch={(selectedDate) => {}}
            />
            <br />
            <br />
            {/* 다이얼로그 스타일 순수 달력 시작 */}
            <Input value={testDate.toLocaleDateString()} onBlur={(e) => {}} />
            <Button
                label="난 달력~"
                className="button-basic-tint -md width-full"
                onClick={() => {
                    ref.current.show(true)
                }}
            />
            <DialogCalendar
                ref={ref}
                isFutureOnly={true}
                title="aaaaaa"
                // today={new Date('2025-05-12')}
                // view="month"
                onChange={setTestDate}
            />

            <br />
            <br />

            <Input value={monthDate.toLocaleDateString()} onBlur={(e) => {}} />
            <Button
                label="바로 월 선택"
                className="button-basic-tint -md width-full"
                onClick={() => {
                    monthRef.current.show(true)
                }}
            />
            <DialogCalendar
                ref={monthRef}
                isFutureOnly={true}
                title="희망입주시기"
                onChange={setMonthDate}
                view="month"
            />
            {/* 다이얼로그 스타일 순수 달력 끝 */}
            <br />
            <br />
            {/* Picker 테스트 시작 */}
            <ScrollPicker
                mode="yearMonth"
                years={yearsitem}
                selectedYear={selectedYear}
                months={monthsitem}
                selectedMonth={selectedMonth}
                handlePlaceholder="기간 선택"
                handleClassName="input-basic -select"
                dialogHeaderName="가입기간"
                visible={picker}
                pickerId="dateSelect"
                onOpen={() => setPicker(true)}
                onClose={() => setPicker(false)}
                onSelectYear={setSelectedYear}
                onSelectMonth={setSelectedMonth}
            />
            <Button
                label="4년 6개월 선택으로 변경"
                className="button-basic-tint -md width-full"
                onClick={() => {
                    setSelectedYear('4년')
                    setSelectedMonth('6개월')
                }}
            />
        </>
    )
}

export default PgCalendar
